module.exports = __webpack_public_path__ + "static/media/13.0fba2f1d.png";